import React from 'react';
import Container from '../Container';
import styles from './index.scss';

const TilesContainer = ({ children }) => (
    <Container>
        <div className={styles.tilesContainer}>{children}</div>
    </Container>
);

export default TilesContainer;
